module.exports = __webpack_public_path__ + "837597b7fc12dc414544744782070f11.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/en.json
// module id = 1117
// module chunks = 0